import { Dropdown } from 'components/filters/Dropdown';
import { Datepicker } from 'components/form/Datepicker';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { convertArrayToDropdownArrayFormat, func_validation, isArrayNotEmpty } from 'functions';
import React, { useEffect, useState } from 'react';

export function useUpdateStatus(props) {
    const { 
        selectedAccount,
        totalRequests, currentTabId,
        updateAccount_requesting,
        isModalVisible_updateStatus, setIsModalVisible_updateStatus
    } = props;

    // States
    const [status, setStatus] = useState();

    function updateAccount() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);

        if (func_validation.isArrayNotEmpty(selectedAccount)) {
            selectedAccount.map((accountDetails = {}, idx) => { 
                let obj = {
                    ...accountDetails,
                    BillStatus: status
                };

                props.updateAccount(obj);
            });
        }
        else {
            Toaster({
                type: "info",
                msg: "Please fill in at least 1 input.",
            });
        }
    }

    let updateStatusModal = (
        <ConfirmationModal
            className={"advance-pay-setup__update-status"}
            headerClassName={"update-status__header"}

            description={"Update status for " + (isArrayNotEmpty(selectedAccount)? selectedAccount.length: 1) + " selected account(s)"}
            input={(
                <div className={"update-status__wrapper d-flex"}>
                    {/* Current Status */}
                    <Dropdown
                        className={"update-status__current-status"}
                        label={"Current Status"}

                        options={convertArrayToDropdownArrayFormat([
                            "Pending", "Confirmed", "Completed", "Inactive"
                        ])}
                        selectedValueLabel_default={currentTabId? currentTabId.charAt(0).toUpperCase() + currentTabId.substring(1):""} 
                        isUpdatingLabel_fromParent

                        isInputOptional isDisabled 
                    />

                    {/* New Status */}
                    <Dropdown  
                        className={"update-status__new-status"}

                        label={"Update Status To"}
                        options={convertArrayToDropdownArrayFormat([
                            "Confirmed", "Inactive"
                        ])}
                        selectedValueLabel_default={(currentTabId === "confirmed")? "Inactive": "Confirmed"} 
                        isUpdatingLabel_fromParent

                        onChange={setStatus}
                    />
                </div>
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_updateStatus}
            updateParentState={setIsModalVisible_updateStatus}
            handleOnConfirm={updateAccount}
            isActionLoading={updateAccount_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        updateStatusModal,
    };
}